var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Table } from 'template/lib';
import useAuth from '../../hooks/useAuth';
import useTitle from '../../hooks/useTitle';
import api from '../../services/api';
import ModalLibrary from "../Modals/ModalLibrary";
import ModalLibraryFTP from "../Modals/ModalLibraryFTP";
import ModalLibraryPublisher from "../Modals/ModalLibraryPublisher";
import { FiDownload, FiEdit2, FiPlus } from "react-icons/fi";
import styles from './styles.module.scss';
import Select from 'react-select';
import { TbCloudUpload } from "react-icons/tb";
var Libraries = function () {
    var _a, _b;
    var apiUrl = process.env.REACT_APP_API_URL;
    var _c = useAuth(), login = _c.login, handleLogout = _c.handleLogout;
    var setTitle = useTitle().setTitle;
    var history = useHistory();
    var _d = useState(0), idToChange = _d[0], setIdToChange = _d[1];
    var _e = useState(0), idLibrary = _e[0], setIdLibrary = _e[1];
    var _f = useState([]), libraryState = _f[0], setLibraryState = _f[1];
    var _g = useState([]), items = _g[0], setItems = _g[1];
    var _h = useState(1), page = _h[0], setPage = _h[1];
    var _j = useState(0), totalPages = _j[0], setTotalPages = _j[1];
    var _k = useState(true), loading = _k[0], setLoading = _k[1];
    var _l = useState(10), pageSize = _l[0], setPageSize = _l[1];
    var _m = useState(false), refresh = _m[0], setRefresh = _m[1];
    var _o = useState(false), hasNext = _o[0], setHasNext = _o[1];
    var _p = useState([]), companiesToSelect = _p[0], setCompaniesToSelect = _p[1];
    var _q = useState({
        label: '',
        value: null
    }), selectedCompany = _q[0], setSelectedCompany = _q[1];
    var _r = useState((_b = (_a = selectedCompany === null || selectedCompany === void 0 ? void 0 : selectedCompany.value) !== null && _a !== void 0 ? _a : login === null || login === void 0 ? void 0 : login.companyId) !== null && _b !== void 0 ? _b : null), companyId = _r[0], setCompanyId = _r[1];
    var _s = useState(false), modalIsOpenLibrary = _s[0], setModalIsOpenLibrary = _s[1];
    var _t = useState(false), modalIsOpenLibraryFTP = _t[0], setModalIsOpenLibraryFTP = _t[1];
    var _u = useState(false), modalIsOpenLibraryPublisher = _u[0], setModalIsOpenLibraryPublisher = _u[1];
    var config = {
        headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) }
    };
    var optionsCompanies = (companiesToSelect || []).map(function (item) { return ({
        label: item.name,
        value: item.id
    }); });
    useEffect(function () {
        var _a;
        setTitle('Bibliotecas');
        if (login && Date.now() > login.expiresIn * 1000) {
            handleLogout();
            history.push('/');
            return;
        }
        if (!login) {
            history.push('/');
            return;
        }
        setLoading(true);
        api.get("/libraries/get-by-company-total-pages/" + login.companyId + "?pageSize=" + pageSize, config)
            .then(function (response) {
            setTotalPages(response.data);
            setHasNext(response.data > page);
        })
            .catch(function (error) {
            console.error('Erro ao carregar total de páginas:', error);
            setTotalPages(0);
            setHasNext(false);
        });
        var idCompanyItem = (_a = selectedCompany.value) !== null && _a !== void 0 ? _a : login.companyId;
        setCompanyId(idCompanyItem);
        api.get("/libraries/get-by-company/" + idCompanyItem + "?page=" + page + "&pageSize=" + pageSize, config)
            .then(function (response) {
            setItems(Array.isArray(response.data) ? response.data : []);
        })
            .catch(function (error) {
            console.error('Erro ao carregar bibliotecas:', error);
            setItems([]);
        })
            .finally(function () { return setLoading(false); });
    }, [refresh, page, pageSize, login, selectedCompany]);
    useEffect(function () {
        if (!(login === null || login === void 0 ? void 0 : login.token))
            return;
        api.get('/companies', config)
            .then(function (response) {
            var companies = Array.isArray(response.data) ? response.data : [];
            setCompaniesToSelect(companies);
        })
            .catch(function (error) {
            console.error('Erro ao carregar empresas:', error);
            setCompaniesToSelect([]);
        });
    }, [login === null || login === void 0 ? void 0 : login.token]);
    useEffect(function () {
        if (idToChange === 0)
            return;
        api.put("/libraries/" + idToChange, libraryState, config)
            .then(function () {
            setRefresh(function (prev) { return !prev; });
        })
            .catch(function (error) {
            console.error('Erro ao atualizar biblioteca:', error);
        });
    }, [libraryState, idToChange]);
    function handleOpenModalLibrary() {
        setModalIsOpenLibrary(true);
    }
    function handleCloseModalLibrary() {
        setModalIsOpenLibrary(false);
    }
    function handleOpenModalLibraryFTP() {
        setModalIsOpenLibraryFTP(true);
    }
    function handleCloseModalLibraryFTP() {
        setModalIsOpenLibraryFTP(false);
    }
    function handleOpenModalLibraryPublisher() {
        setModalIsOpenLibraryPublisher(true);
    }
    function handleCloseModalLibraryPublisher() {
        setModalIsOpenLibraryPublisher(false);
    }
    var lineBtnLibraryFTP = [
        {
            fn: function (id) {
                setIdLibrary(id);
                handleOpenModalLibraryFTP();
            },
            icon: _jsx(FiEdit2, { size: 16 }, void 0),
            name: 'Informações FTP'
        },
        {
            fn: function (id) {
                window.open(apiUrl + "libraries/" + id + "/download-library-installer", "_blank");
            },
            icon: _jsx(FiDownload, { size: 16 }, void 0),
            name: 'Download Instalador Biblioteca'
        }
    ];
    var menuBtn = [
        {
            fn: function () {
                handleOpenModalLibrary();
                setRefresh(function (prev) { return !prev; });
            },
            icon: _jsx(FiPlus, { size: 20 }, void 0),
            id: 1,
            title: 'Nova Biblioteca'
        }
    ];
    var btnDefinePublisher = {
        fn: function () {
            handleOpenModalLibraryPublisher();
        },
        icon: _jsx(TbCloudUpload, { size: 20 }, void 0),
        id: 1,
        title: 'Permissões de Upload'
    };
    if ((items === null || items === void 0 ? void 0 : items.length) > 0 && (login === null || login === void 0 ? void 0 : login.hasPluginMaker) == true && ((login === null || login === void 0 ? void 0 : login.role) === 'Administrator' || (login === null || login === void 0 ? void 0 : login.role) === 'CustomerAdmin')) {
        menuBtn.push(btnDefinePublisher);
    }
    var customStyles = {
        control: function (provided) { return (__assign(__assign({}, provided), { minHeight: "20px", boxShadow: 'none', fontSize: "14px !important" })); },
        input: function (provided) { return (__assign(__assign({}, provided), { padding: "0px" })); },
        path: function (provided) { return (__assign(__assign({}, provided), { fill: "black" })); },
        indicatorsContainer: function (provided) { return (__assign(__assign({}, provided), { height: "20px" })); },
        indicatorSeparator: function (provided) { return (__assign(__assign({}, provided), { height: "0px" })); },
        dropdownIndicator: function (provided) { return (__assign(__assign({}, provided), { padding: "2px", color: "black" })); }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: styles.container }, { children: [(login === null || login === void 0 ? void 0 : login.role) === 'Administrator' &&
                        _jsxs("div", __assign({ className: styles.divSelectCompany }, { children: [_jsx("label", { children: "Empresa:" }, void 0), _jsx(Select, { styles: customStyles, placeholder: "Selecione uma empresa", options: optionsCompanies, value: selectedCompany, onChange: function (option) {
                                        setSelectedCompany(option || { label: '', value: null });
                                    }, className: styles.selectCompany }, void 0)] }), void 0), _jsx(Table, { setSize: setPageSize, size: pageSize, hasNext: hasNext, page: page, setPage: setPage, data: items, setData: setItems, changeExistentContent: setLibraryState, totalPAges: totalPages, loading: loading, title: 'Bibliotecas', setIdToChange: setIdToChange, refresh: setRefresh, editable: true, headerButtons: menuBtn, lineButton: lineBtnLibraryFTP, columns: [
                            { label: 'ID', key: 'id' },
                            { label: 'Nome', key: 'name' },
                            { label: 'Data de Compilação', key: 'dateCompilation' },
                            { label: 'Principal', key: 'select_main' },
                        ] }, void 0)] }), void 0), _jsx(ModalLibrary, { refresh: refresh, setRefresh: setRefresh, modalIsOpenLibrary: modalIsOpenLibrary, handleOpenModalLibrary: handleOpenModalLibrary, handleCloseModalLibrary: handleCloseModalLibrary, companyId: companyId }, void 0), _jsx(ModalLibraryFTP, { libraryId: idLibrary, modalIsOpenLibraryFTP: modalIsOpenLibraryFTP, handleOpenModalLibraryFTP: handleOpenModalLibraryFTP, handleCloseModalLibraryFTP: handleCloseModalLibraryFTP }, void 0), _jsx(ModalLibraryPublisher, { modalIsOpenLibraryPublisher: modalIsOpenLibraryPublisher, handleOpenModalLibraryPublisher: handleOpenModalLibraryPublisher, handleCloseModalLibraryPublisher: handleCloseModalLibraryPublisher, companyId: companyId }, void 0)] }, void 0));
};
export default Libraries;
